import {
  GraduationCap,
  Calendar,
  CheckCircle,
  AlertTriangle,
  Award,
  Clock,
  XCircle,
  Send,
  Bell,
  ShieldAlert,
  type LucideIcon,
} from 'lucide-react';

export type NotificationCategory =
  | 'exam_graded'
  | 'exam_scheduled'
  | 'enrollment_confirmed'
  | 'violation_detected'
  | 'certificate_issued'
  | 'exam_reminder'
  | 'exam_failed'
  | 'exam_submitted'
  | 'plagiarism_detected';

export interface CategoryConfig {
  icon: LucideIcon;
  colorClass: string;
  bgClass: string;
  label: string;
}

export const NOTIFICATION_CATEGORIES: Record<NotificationCategory, CategoryConfig> = {
  exam_graded: {
    icon: GraduationCap,
    colorClass: 'text-teal-400',
    bgClass: 'bg-teal-500/10',
    label: 'Exam Graded',
  },
  exam_scheduled: {
    icon: Calendar,
    colorClass: 'text-blue-400',
    bgClass: 'bg-blue-500/10',
    label: 'Exam Scheduled',
  },
  enrollment_confirmed: {
    icon: CheckCircle,
    colorClass: 'text-green-400',
    bgClass: 'bg-green-500/10',
    label: 'Enrollment Confirmed',
  },
  violation_detected: {
    icon: AlertTriangle,
    colorClass: 'text-red-400',
    bgClass: 'bg-red-500/10',
    label: 'Violation Detected',
  },
  certificate_issued: {
    icon: Award,
    colorClass: 'text-amber-400',
    bgClass: 'bg-amber-500/10',
    label: 'Certificate Issued',
  },
  exam_reminder: {
    icon: Clock,
    colorClass: 'text-purple-400',
    bgClass: 'bg-purple-500/10',
    label: 'Exam Reminder',
  },
  exam_failed: {
    icon: XCircle,
    colorClass: 'text-red-400',
    bgClass: 'bg-red-500/10',
    label: 'Exam Failed',
  },
  exam_submitted: {
    icon: Send,
    colorClass: 'text-blue-400',
    bgClass: 'bg-blue-500/10',
    label: 'Exam Submitted',
  },
  plagiarism_detected: {
    icon: ShieldAlert,
    colorClass: 'text-red-400',
    bgClass: 'bg-red-500/10',
    label: 'Plagiarism Detected',
  },
};

export const DEFAULT_CATEGORY_CONFIG: CategoryConfig = {
  icon: Bell,
  colorClass: 'text-teal-400',
  bgClass: 'bg-teal-500/10',
  label: 'Notification',
};

export function getCategoryConfig(category?: string): CategoryConfig {
  if (category && category in NOTIFICATION_CATEGORIES) {
    return NOTIFICATION_CATEGORIES[category as NotificationCategory];
  }
  return DEFAULT_CATEGORY_CONFIG;
}

export function formatTimeAgo(dateStr: string): string {
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffSec < 60) return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  if (diffHour < 24) return `${diffHour}h ago`;
  if (diffDay < 7) return `${diffDay}d ago`;
  return date.toLocaleDateString();
}
